import '@expo/metro-runtime';
import { StoreProvider } from 'easy-peasy';
import { registerRootComponent } from 'expo';
import App from './App';
import { NotificationProvider } from '@/components/ui/therapist/Notification/NotificationProvider';
import store from './stores/store';
import {
  init as initSentry,
  reactNativeTracingIntegration,
  reactNavigationIntegration,
} from '@sentry/react-native';
import constants from '@/config/constants';

export const reactNavigationIntegrationForSentry = reactNavigationIntegration({
  enableTimeToInitialDisplay: true,
});

initSentry({
  dsn:
    constants.sentryDsn ||
    'https://ca75223dfbbfa00355e00bd6f7bb7b42@sentry.neolexon.de/4509357247627344',
  sendDefaultPii: false,
  enabled: constants.sentryEnabled,
  environment: constants.environment,
  release: constants.appVersion,
  enableLogs: constants.sentryEnabled,
  initialScope: {
    tags: {
      appMode: constants.appMode,
    },
  },
  integrations: [
    reactNativeTracingIntegration(),
    reactNavigationIntegrationForSentry,
  ],
  tracesSampleRate:
    constants.environment === 'production' || 'staging' ? 0.1 : 0, // Only enable in production and staging at a lower sample rate to avoid over-quotas
});

function EntryComponent() {
  return (
    <StoreProvider store={store}>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </StoreProvider>
  );
}

/* eslint-disable import/no-unused-modules */
export default registerRootComponent(EntryComponent);
